<script setup lang="ts">
import MainContainer from '../Main/Container.vue';
import MainRoot from '../Main/Root.vue';

const props = defineProps<{
	app: 'auth' | 'camPortal';
}>();
</script>

<template>
	<div class="layout-entry">
		<MainContainer>
			<MainRoot>
				<div class="entry-container">
					<slot />

					<HmBackdrop :app="props.app" v-if="$screen.md" />
					<HmCopyright :app="props.app" is-absolute v-else />
				</div>
			</MainRoot>
		</MainContainer>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.entry-container
	{
		@include flex;
		flex-direction:column;
		min-height:100vh;
		padding-block-end:var(--spacing-5xl);
		position:relative;
		z-index:1;

		@include responsive(md)
		{
			justify-content:center;
			padding-block-start:var(--spacing-lg);
		}
	}
}
</style>
